import { client } from "./client";

export const getContentById = async (id) => {
  const response = await client.getEntries({
    content_type: id,
  });
  const { items } = response;
  return items.map((e) => e.fields);
};
